import { Modal } from 'react-responsive-modal';
import PayOutChartPerLeadProgram from 'components/PayOutChartPerLeadProgram';

const PayOutChartPerLeadProgramPopup = ({ open, close }) => {
    return (
        <>
            <Modal classNames={{ overlay: 'contact-support-overlay', modal: 'payout-chat-modal', }}
                open={open}
                onClose={close}

                center>
                <PayOutChartPerLeadProgram />

            </Modal>
        </>

    )
}

export default PayOutChartPerLeadProgramPopup;